module.exports = __webpack_public_path__ + "img/vegetable-pumpkin-350x184.f43879f9.jpg";